import { render, staticRenderFns } from "./AppointmentRequests.vue?vue&type=template&id=44e0f0d5"
import script from "./AppointmentRequests.vue?vue&type=script&lang=js"
export * from "./AppointmentRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports